import React from "react";
import { Box, Card, CardContent, Typography, Grid } from "@mui/material";
import IndividualUsersSVG from "../../assets/IndividualUsers";
import GuardifyShieldSVG from "../../assets/GuardifyShield";
import HandshakeSVG from "../../assets/Handshake Icon";
import CentersSupportedSVG from "../../assets/CentersSupported";
import { StatsData } from "../../types";

interface StatsOverviewProps {
  data: StatsData;
  isExport?: boolean;
}

const StatsOverview: React.FC<StatsOverviewProps> = ({
  data,
  isExport = false,
}) => {
  const stats = [
    {
      label: "Children Protected",
      value: data.childrenProtected.toLocaleString(),
      type: "svg",
      icon: GuardifyShieldSVG,
    },
    {
      label: "Centers Supported",
      value: data.centersSupported.toLocaleString(),
      type: "icon",
      icon: CentersSupportedSVG,
    },
    {
      label: "Individual Users",
      value: data.individualUsers.toLocaleString(),
      type: "icon",
      icon: IndividualUsersSVG,
    },
    {
      label: "Agencies Using Guardify",
      value: data.agenciesUsingGuardify.toLocaleString(),
      type: "svg",
      icon: HandshakeSVG,
    },
  ];

  return (
    <Grid container spacing={isExport ? 0 : 8}>
      {stats.map((stat, index) => {
        const IconComponent = stat.icon;
        return (
          <Grid
            item
            xs={isExport ? 3 : 12}
            sm={isExport ? 3 : 6}
            lg={3}
            key={index}
          >
            <Card
              sx={{
                width: "100%",
                height: isExport ? "100%" : "auto",
                transition: isExport ? "none" : "all 0.3s ease",
                "&:hover": isExport
                  ? "none"
                  : {
                      transform: "translateY(-2px)",
                      boxShadow: "0 4px 12px 0 rgb(0 0 0 / 0.15)",
                    },
                aspectRatio: isExport ? "1/1" : "3/1",
                paddingBottom: 0,
              }}
            >
              <CardContent
                className={isExport ? "export-card-content" : ""}
                sx={{
                  p: isExport ? 0 : 3,
                  px: isExport ? 0 : 2,
                  height: "100%",
                  width: "100%",
                  display: "flex",
                  flexDirection: isExport ? "column" : "row",
                  justifyContent: isExport ? "center" : "space-between",
                  gap: isExport ? 0 : 2,
                  alignItems: "center",
                }}
              >
                <Box
                  sx={{
                    width: isExport ? "40%" : "20%",
                    height: isExport ? "50%" : "auto",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <IconComponent />
                </Box>
                <Box
                  sx={{
                    width: isExport ? "100%" : "80%",
                    display: "flex",
                    flexDirection: "column",
                  }}
                >
                  <Typography
                    variant="h3"
                    component="div"
                    sx={{
                      fontWeight: 700,
                      color: "text.primary",
                      textAlign: isExport ? "center" : "left",
                      fontSize: isExport ? "1.5rem" : "1.25rem",
                    }}
                  >
                    {stat.value}
                  </Typography>
                  <Typography
                    variant={isExport ? "body2" : "h6"}
                    color="text.secondary"
                    sx={{
                      fontWeight: 500,
                      textAlign: isExport ? "center" : "left",
                    }}
                  >
                    {stat.label}
                  </Typography>
                </Box>
              </CardContent>
            </Card>
          </Grid>
        );
      })}
    </Grid>
  );
};

export default StatsOverview;
